import React, { useRef } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { pink } from "@mui/material/colors";
import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useSearchParams } from "react-router-dom";
import ErrorText from "../common/ErrorText";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import { useCookies } from "react-cookie";
import apiCall from "../../helpers/apifactory";

const YOUR_PRIVATE_KEY = "6Le3utQhAAAAAKR-L_9-laElwYvGEqxDWSBOMRps";

const MmsForm = () => {
  const [cookies, setCookie] = useCookies(["prodType", "subCat"]);
  const [token, settoken] = useState(null);
  const [Captcha, setCaptcha] = useState(null);
  useEffect(() => {
    console.log("======8", cookies);
  }, [cookies]);

  // const onChange = (value) => {
  //     setCaptcha(value)
  //     console.log("Captcha value:", value);
  // };

  const submitHandler = async () => {
    if (Captcha == null) {
      alert("please verify code");
      return;
    }

    const res = await axios.post(
      `https://www.google.com/recaptcha/api/siteverify?secret=${YOUR_PRIVATE_KEY}&response=${Captcha}`
    );

    // Extract result from the API response
    if (res.data.success) console.log("Human");
    else console.log("BOT!!!");
  };

  function onChange(value) {
    console.log("Captcha value:", value);
  }

  const PleaseDoCaptcha = () => {
    alert("please do captcha");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("you submit a form");
    // const token = captchaRef.current.getValue();
    // captchaRef.current.reset();
    // ReCAPTCHA.current.reset();
    // dispatch(handleApi({CustomerName,}))
  };

  const [termCond, setTermCond] = useState(false);
  const [under, setUnder] = useState(false);

  const formik = useFormik({
    initialValues: {
      compName: "",
      bussName: "",
      city: "",
      BussIndustry: "",
      BussType: "",
      CompRegNum: "",
      gst_ntn_cnic: "",
      taxFiler: "yes",
      name: "",
      designation: "",
      email: "",
      mobNum: "",
      LandlineNum: "",
      cnic: "",
      // orgName: '',
      // industry: '',
      // name: '',
      // designation: '',
      // number: '',
      // email: '',
      // teleNum: '',
      // city: '',
      // address: '',
      // from: '',
      // to: '',
      recaptcha: "",
      // termCond: false,
      // undertak: false,
      // capcha: false
    },
    validationSchema: Yup.object({
      orgName: Yup.string().required("This is Required"),
      industry: Yup.string().required("This is Required"),
      name: Yup.string().required("This is Required"),
      designation: Yup.string().required("This is Required"),
      number: Yup.string().required("This is Required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      teleNum: Yup.string().required("This is Required"),
      city: Yup.string().required("This is Required"),
      address: Yup.string().required("This is Required"),
      from: Yup.string().required("This is Required"),
      to: Yup.string().required("This is Required"),
      recaptcha: Yup.string().required(),
      // termCond: Yup.boolean().required('Agree to our terms & conditions'),
      // undertak: Yup.boolean().required('Agree to our undertaking'),
      // capcha: Yup.boolean().required('Check Captcha'),
    }),
    onSubmit: (values) => {
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      axios
        .post(
          "https://devconnect.tcscourier.com/notification/api/Email/sendEmail",
          {
            toEmailID: "customerservices@tcs.com.pk",
            fromEmailID: "noreply@tcs.com.pk",
            emailSubject: "Applicant Information",
            emailText: `
                    organisation name : ${values.orgName} \n
                    Industry : ${values.industry} \n
                    name : ${values.name} \n
                    name : ${values.designation} \n
                    number : ${values.number} \n
                    email : ${values.email} \n
                    TelePhone : ${values.teleNum} \n
                    city : ${values.city} \n
                    address : ${values.address} \n
                    address : ${values.address} \n
                    `,
            cc: values?.email,
            bcc: values?.email,
            attachments: [],
            replyTo: values?.custEmail,
          },
          config
        )
        .then(() => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          // setFileName({ name: "Attach Resume/CV", size: '', type: '' })
          formik.setTouched({}, false);
        })
        .catch(console.log);
    },
  });
  const [show, setShow] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);

  useEffect(() => {
    console.log("------>");
    apiCall.middlewareAuthToken().then((token) => {
      const {
        data: { result: accessToken },
      } = token;
      settoken(accessToken.accessToken);
    });
  }, []);

  // let { search } = useLocation();

  // const query = new URLSearchParams(search);
  // const paramField = query.get('field');
  // const paramValue = query.get('value');
  // console.log('00000000000', paramField)
  // console.log('00000000000', paramValue)

  // const [searchParams] = useSearchParams();
  // console.log('0000000', searchParams);
  const { prodType, subCat } = cookies;
  // console.log('111111111111111111111111111111111',prodType)

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">MMS</h1>
        <div className="flex  justify-center items-center">
          <h2 className="text-[1.1rem]">Account Opening Form</h2>
        </div>
      </div>
      {/* <!-- Heading --> */}
      <form onSubmit={handleSubmit}>
        <div className="my-[3rem]">
          {/* Old Form */}
          {/* <div style={{ border: '5px solid red' }} className="flex flex-col justify-center items-center mt-[1rem] ">
                        <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500 mt-0 pt-0">


                            <div className="flex gap-4 mt-4">

                                <div className="flex-1 flex flex-col gap-1">
                                    <h2 className="font-bold text-[1.1rem] mb-5 mt-0">Applicant Information</h2>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    disabled={true}
                                                    value={prodType}
                                                    style={{ fontWeight: "bolder" }}
                                                    type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                </label>
                                            </div>
                                            <ErrorText text={''} />
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    style={{ fontWeight: "bolder" }}
                                                    disabled={true}
                                                    value={subCat}
                                                    type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label style={{ fontWeight: "bolder" }} for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                </label>
                                            </div>
                                            <ErrorText text={''} />
                                        </div>
                                    </div>

                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    name="orgName"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.orgName} type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Organization name
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.orgName && formik.errors.orgName} />
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    name="industry"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.industry}

                                                    type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Industry
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.industry && formik.errors.industry} />
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input
                                                    name="name"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name}
                                                    type="text"  id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Contact Person Name
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.name && formik.errors.name} />
                                        </div>
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input

                                                    name="designation"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.designation}



                                                    type="email" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Contact Person Designation
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.designation && formik.errors.designation} />
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input
                                                    name="number"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.number}
                                                    type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Contact Number
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.number && formik.errors.number} />
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input

                                                    name="email"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.email}
                                                    type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Email
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.email && formik.errors.email} />
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input
                                                    name="teleNum"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.teleNum}
                                                    type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Telephone Number
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.teleNum && formik.errors.teleNum} />
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    name="city"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.city}
                                                    type="text" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    City
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.city && formik.errors.city} />
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-8">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <textarea
                                                    name="address"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.address}
                                                    type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label

                                                    for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Company Address
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.address && formik.errors.address} />
                                        </div>
                                    </div>
                                    <p style={{}}>Best time to contact:</p>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input
                                                    name="from"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.from}
                                                    type="date" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Date
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.from && formik.errors.from} />
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <input
                                                    name="to"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.to}
                                                    type="time" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />

                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Time
                                                </label>
                                            </div>
                                            <ErrorText text={formik.touched.to && formik.errors.to} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="flex-1 flex flex-col"></div>
                            </div>

                        </div>
                    </div> */}
          {/* Company Information */}
          <div className="flex flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[1.1rem] mb-5 mt-0">
                    Company Information
                  </h2>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={prodType}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Company Name*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Name*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>

                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="floating_outline"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          // name="city"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.city}
                        >
                          <option>Please Select</option>
                          <option>Karachi</option>
                          <option>Lahore</option>
                        </select>
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your City*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="floating_outline"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          // name="city"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.city}
                        >
                          <option>Please Select</option>
                          <option>Industry 1</option>
                          <option>Industry 2</option>
                          <option>Industry 3</option>
                        </select>
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Industry*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <select
                          id="floating_outline"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          // name="city"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.city}
                        >
                          <option>Please Select</option>
                          <option>Type 1</option>
                          <option>Type 2</option>
                          <option>Type 3</option>
                        </select>
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Type*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          // name="designation"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.designation}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Company registration No
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          // name="designation"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.designation}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          GST/NTN/CNIC
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="floating_outline"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          // name="city"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.city}
                        >
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Tax Filer
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/* Contact Person Details */}
          <div className="flex flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[1.1rem] mb-5 mt-0">
                    Contact Person Details
                  </h2>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={prodType}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Name*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="text"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Designation*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>

                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="email"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Email*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.orgName && formik.errors.orgName}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Mobile #*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.industry && formik.errors.industry}
                      />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Landline #
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.name && formik.errors.name}
                      />
                    </div>
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          CNIC*
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.designation &&
                          formik.errors.designation
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/* Account Information */}
          <div className="flex flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[1.1rem] mb-5 mt-0">
                    Account Information
                  </h2>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="floating_outline"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          // name="city"
                          // onChange={formik.handleChange}
                          // onBlur={formik.handleBlur}
                          // value={formik.values.city}
                        >
                          <option>Please Select</option>
                          <option>Express</option>
                          <option>Overland</option>
                          <option>Warehousing</option>
                          <option>Sentiments</option>
                          <option>MMS</option>
                        </select>
                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Product Selection*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          // value={subCat}
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Average Monthly Shipments*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                  </div>

                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative ">
                        <input
                          // value={subCat}
                          type="number"
                          id="floating_outlined"
                          className="block px-2.5 pb-2 pt-2 w-[49%] text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="floating_outlined"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Average Monthly Weight (kgs)*
                        </label>
                      </div>
                      <ErrorText text={""} />
                    </div>
                    {/* <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <select
                                                    id="floating_outline"
                                                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                                                    placeholder=" "
                                                // name="city"
                                                // onChange={formik.handleChange}
                                                // onBlur={formik.handleBlur}
                                                // value={formik.values.city}
                                                >
                                                    <option>Please Select</option>
                                                    <option>Industry 1</option>
                                                    <option>Industry 2</option>
                                                    <option>Industry 3</option>
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Your Business Industry*
                                                </label>
                                            </div>
                                            <ErrorText text={''} />
                                        </div> */}
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/* <div className="flex flex-col justify-center items-center mt-[1rem] ">
                        <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500">
                            <h2 className="font-bold text-[1.1rem]">Billing Address</h2>
                            <div className="flex gap-4 mt-4">
                                <div className="flex-1 flex flex-col gap-4">
                                    <div className="flex gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Address
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
                                                    <option>City</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    City
                                                </label>
                                            </div>
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
                                                    <option>Province</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Province
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="flex-1 flex flex-col"></div>
                            </div>
                        </div>
                    </div> */}
          {/* <div className="flex flex-col justify-center items-center mt-[1rem] ">
                        <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto]rounded-md transition-all duration-500">
                            <h2 className="font-bold text-[1.1rem]">Pickup Address</h2>
                            <div className="flex gap-4 mt-4">
                                <div className="flex-1 flex flex-col gap-4">
                                    <div className="flex gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Address
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
                                                    <option>City</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    City
                                                </label>
                                            </div>
                                        </div>
                                        <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
                                            <div className="relative">
                                                <select id="floating_outline" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" ">
                                                    <option>Province</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Province
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Cell Number
                                                </label>
                                            </div>
                                        </div>
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Landline Number
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:flex grid flex-col gap-4">
                                        <p className="mt-2  text-lg">Product</p>
                                        <div className="md:flex grid gap-4">
                                            <div className="flex-1 flex flex-col">

                                                <div className="flex items-center mb-3">
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                            label={<p className="text-sm">Clothing</p>}
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                            label={<p className="text-sm">Books</p>}
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                            label={<p className="text-sm">Watches</p>}
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                            label={<p className="text-sm">Perfumes and Cosmetics</p>}
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                            label={<p className="text-sm">Sports</p>}
                                                        />
                                                    </FormGroup>
                                                </div>

                                            </div>
                                            <div className="flex-1 sm:flex grid flex-col">
                                                <div className="relative">
                                                    <div className="flex items-center mb-3">
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                                label={<p className="text-sm">Home Decor</p>}
                                                            />
                                                            <FormControlLabel
                                                                control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                                label={<p className="text-sm">Home Appliances</p>}
                                                            />
                                                            <FormControlLabel
                                                                control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                                label={<p className="text-sm">Health and Fitness</p>}
                                                            />
                                                            <FormControlLabel
                                                                control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                                label={<p className="text-sm">Mobile and Tablets (PTA Approved)</p>}
                                                            />
                                                            <FormControlLabel
                                                                control={<Checkbox Checked sx={{ '&.Mui-checked': { color: pink[600] }, }} />}
                                                                label={<p className="text-sm">Computer, Peripherals and Accessories</p>}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:flex grid gap-4">
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Average Shipments per Month
                                                </label>
                                            </div>
                                        </div>
                                        <div className="MuiFormControl-root MuiTextField-root flex-1">
                                            <div className="relative">
                                                <input type="Number" id="floating_outlined" className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer" placeholder=" " />
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Average Weight per Month
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex gap-4">
                                <div className="flex-1 flex flex-col"></div>
                            </div>
                        </div>
                    </div> */}
          <div className="flex flex-col justify-center items-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500">
              <h2 className="font-bold text-[1.1rem]">
                Rates &amp; Acceptance
              </h2>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <div className="flex items-center mb-3">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onClick={() => setTermCond(!termCond)}
                            sx={{ "&.Mui-checked": { color: pink[600] } }}
                          />
                        }
                        label={
                          <p className="text-sm">
                            I have read and hereby accept the{" "}
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://customeraccount.tcscourier.com/accountopening/TermsAndCond.aspx"
                              className="text-[#337ab7]"
                            >
                              Terms and Conditions
                            </a>
                            *
                          </p>
                        }
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            onClick={() => setUnder(!under)}
                            Checked
                            sx={{ "&.Mui-checked": { color: pink[600] } }}
                          />
                        }
                        label={
                          <p className="text-sm">
                            I have read and hereby accept the{" "}
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://customeraccount.tcscourier.com/accountopening/RegUndertaking.aspx"
                              className="text-[#337ab7]"
                            >
                              Undertaking
                            </a>
                            *
                          </p>
                        }
                      />
                    </FormGroup>
                  </div>
                  <p className="mt-4 text-xs">
                    A TCS sales representative will contact you within next 24
                    hours (during workdays) for further details and
                    confirmations.
                  </p>

                  {/* <div className="g-recaptcha-inner mt-[2rem]">
                                <ReCAPTCHA
                                    sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                    onChange={PleaseDoCaptcha}
                                    data-theme='dark'
                                
                                />
                            </div>  */}

                  {/* <GoogleReCaptcha
        onVerify={onVerify}
        refreshReCaptcha={refreshReCaptcha}
      /> */}

                  {/* <reCAPTCHA
sitekey={process.env.REACT_APP_SITE_KEY}
ref={captchaRef}
/> */}

                  {/* <form onSubmit={() => { recaptchaRef.current.execute(); }}>
    <ReCAPTCHA
      ref={recaptchaRef}
      size="invisible"
      sitekey="Your client site key"
      onChange={onChange}
    />
  </form>, */}
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>

            {/* <div className="flex flex-col justify-center items-center mt-[1rem] mb-[0.6rem] ">
                    <div className="flex gap-4 w-[45rem]">
                        <div className='g-recaptcha'>
                            <ReCAPTCHA
                                // sitekey="6Le3utQhAAAAAOvAHs5QXdniSKLmvtTn0vM7GUzA"
sitekey="6LeQwecjAAAAACyoUlVWbSpm-LaXakw8mAyWNfM6"
                                onChange={onChange}                            
                            />
                        </div>
                    </div>               
                </div> */}
            <div className="flex flex-col justify-center items-center mt-[1rem] mb-[0.6rem] ">
              <div className="flex gap-4 md:w-[45rem] sm:w-[43rem] w-[18.5rem]">
                <div className="g-recaptcha">
                  <ReCAPTCHA
                    // sitekey="6Le3utQhAAAAAOvAHs5QXdniSKLmvtTn0vM7GUzA"
                    // sitekey="6LeQwecjAAAAACyoUlVWbSpm-LaXakw8mAyWNfM6"
                    sitekey={process.env.REACT_APP_CAPTCH}
                    // sitekey="6Lf3Eh0lAAAAACIaOrGsuJqodVFcohx81VLCwm3k"
                    onChange={(value) => {
                      console.log("Captcha value:", value);
                      formik.setFieldValue("recaptcha", value);
                    }}
                  />
                </div>
              </div>
            </div>

            <button
              type="submit"
              onClick={formik.handleSubmit}
              className="text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[17rem] rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default MmsForm;
